import TomSelect from "tom-select";

document.addEventListener('turbolinks:load', () =>
	startSelects()	
)

function startSelects() {
	new TomSelect("#select-medium_types",{ plugins: { remove_button:{ title:'Remove this item', } }, maxItems: 3 });
	new TomSelect("#select-industries",{ plugins: { remove_button:{ title:'Remove this item', } }, maxItems: 3 });
	new TomSelect("#select-countries",{ plugins: { remove_button:{ title:'Remove this item', } }, maxItems: 3 });
	new TomSelect("#select-collections",{ plugins: { remove_button:{ title:'Remove this item', } }, maxItems: 2 });
	new TomSelect("#select-regions",{ plugins: { remove_button:{ title:'Remove this item', } }, maxItems: 2 });
}